import { render, staticRenderFns } from "./ProdutoModule.vue?vue&type=template&id=58d7e688"
import script from "./ProdutoModule.vue?vue&type=script&lang=js"
export * from "./ProdutoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports